import {isEqual} from 'lodash';
import {HttpRequestClass} from '../http';

class DataLoader {
  get filters(): any {
    return this._filters;
  }
  get lastResponse(): any {
    return this._lastResponse;
  }

  set lastResponse(value: any) {
    this._lastResponse = value;
  }
  // tslint:disable-next-line:variable-name
  private _filters: any
  private url: string
  // tslint:disable-next-line:variable-name
  private _lastResponse: any
  constructor(url: string) {
    this.url = url;
    this._lastResponse = undefined;
  }
  /**
   * @param filters
   * @param abortController
   */
  get(filters: any,  abortController?: AbortController) {
    if (!isEqual(filters, this._filters) && Object.keys(filters).length > 0) {
      let signal;
      if (abortController) {
        signal = abortController.signal;
      }
      this._filters = filters;
      const httpRequest = new HttpRequestClass();
      const method = 'POST';
      return httpRequest.fetch(
        this.url, {data: filters, method, signal}).then((res) => {
          return res;
      })
    } else {
      return new Promise((resolve) => {
        resolve(this._lastResponse);
      })
    }
  }
}

export const myAlertsDataLoader = new DataLoader('scripts/my_alerts/get_alerts');
export const myAlertsCustomerInfoDataLoader = new DataLoader('scripts/alert_form/get_bulk_coaching_form_info');
export const attributesTableLoader = new DataLoader('scripts/drilldown_attr');

export const drilldownTrendDataLoader = new DataLoader('scripts/drilldown_trend');
export const drilldownDistributionLoader = new DataLoader('scripts/distribution');
export const drilldownComparisonLoader = new DataLoader('scripts/avid');

export const individualSurveysDashboardLoader = new DataLoader('scripts/coachingoverview');

export const commentTrendDataLoader = new DataLoader('scripts/comment_trend');
export const commentCategoriesDataLoader = new DataLoader('scripts/comment_categories');
export const commentAllDataLoader = new DataLoader('scripts/comment_allcomments');
export const commentMoodsDataLoader = new DataLoader('scripts/comment_moods');
